var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-input",
    {
      attrs: {
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        min: 0,
        max: 100,
      },
      model: {
        value: _vm.model,
        callback: function ($$v) {
          _vm.model = $$v
        },
        expression: "model",
      },
    },
    [
      _c(
        "template",
        { slot: "append" },
        [_c("font-awesome-icon", { attrs: { icon: ["fas", "percentage"] } })],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }